import { useState, useEffect } from 'react';
import Desktop from './components/Desktop';
import { WindowProvider } from './contexts/WindowContext';
import AdminPanel from './components/AdminPanel';
import PublicVideoPlayer from './components/PublicVideoPlayer';
import './styles/windows-xp.css';

function App() {
  const [currentRoute, setCurrentRoute] = useState(window.location.pathname);

  // Handle browser navigation
  useEffect(() => {
    const handlePopState = () => {
      setCurrentRoute(window.location.pathname);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Protected admin panel route
  if (currentRoute === '/admin-panel') {
    return (
      <AdminPanel 
        isVisible={true} 
        onClose={() => window.history.back()} 
        onStreamStateChange={() => {}} 
      />
    );
  }

  // Public video player route
  if (currentRoute === '/watch') {
    return <PublicVideoPlayer onLoginClick={() => {}} />;
  }

  // Default desktop interface
  return (
    <WindowProvider>
      <div className="w-full h-screen overflow-hidden">
        <Desktop />
      </div>
    </WindowProvider>
  );
}

export default App;